import { render, staticRenderFns } from "./shopGoods.vue?vue&type=template&id=b2bc797e&scoped=true"
import script from "./shopGoods.vue?vue&type=script&lang=js"
export * from "./shopGoods.vue?vue&type=script&lang=js"
import style0 from "./shopGoods.vue?vue&type=style&index=0&id=b2bc797e&lang=scss&scoped=true"
import style1 from "./shopGoods.vue?vue&type=style&index=1&id=b2bc797e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc797e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bc797e')) {
      api.createRecord('b2bc797e', component.options)
    } else {
      api.reload('b2bc797e', component.options)
    }
    module.hot.accept("./shopGoods.vue?vue&type=template&id=b2bc797e&scoped=true", function () {
      api.rerender('b2bc797e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/shopGoods.vue"
export default component.exports